export const BASE_URL = 'https://car.bidcarsindia.com';

// export const BASE_URL = 'http://localhost:8080';